import { AUDIENCE_STATUS, AUDIENCE_TYPE } from 'modules/audiences/config';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';

export const shouldShowTooltip = data => {
    const { status, type } = data;
    return type === AUDIENCE_TYPE.PBP_LOOKALIKE && status === AUDIENCE_STATUS.REJECTED;
};

export const CustomAudiencesRejectedStatusTooltip = () => {
    return (
        <div>
            <FormattedMessage
                id="report.audienceStatus.reject.pixelPredictive.tooltip"
                defaultMessage="Rejected due to insufficient scale or model performance. The model is continuously running, so this audience may become active and targetable at anytime."
            />
        </div>
    );
};
